import React, { Component, useRef, useState, useEffect } from 'react';
import {Link, useNavigate, useParams } from "react-router-dom";
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import * as utils from '../common/Utils.js'
import { useAdminGuard } from '../hooks/useAdminGuard.js';

import { collection, query, where, getDoc, getDocs, setDoc, updateDoc, doc, Timestamp } from "firebase/firestore";
import { db } from '../firebase.js';

const AdminTeamsNew = () => {
  const navigate = useNavigate();
  const { currentUser, isReady } = useAdminGuard();

  function displayEditTeam () {
    return (
      <>
        <form>
          <div className="form-row">
            <div className="form-group">
              <label for="inputTeamName">Team Name</label>
              <input type="text" className="form-control" id="inputTeamName" required></input>
            </div>
            <div className="form-group">
              <label for="inputTeamNameAbbv">Team Name Abbreviated</label>
              <input type="text" className="form-control" id="inputTeamNameAbbv" required></input>
            </div>
          </div>
          <div className="form-group">
            <label for="inputTeamID">ID</label>
            <input type="text" className="form-control" id="inputTeamID" required></input>
          </div>
          <div className="form-group">
            <label for="inputTeamBio">Bio</label>
            <textarea type="text" className="form-control" id="inputTeamBio" required></textarea>
          </div>
          <button className="btn btn-dark" type="button" onClick={saveTeam}>Create New Team</button>
        </form>
      </>
    )
  }

  async function saveTeam () {
    let tmNew = {
      bio: document.getElementById('inputTeamBio').value.split('\n'),
      id: document.getElementById('inputTeamID').value,
      name: document.getElementById('inputTeamName').value,
      nameAbbv: document.getElementById('inputTeamNameAbbv').value
    }

    await setDoc(doc(db, "teams", tmNew.id), tmNew);

    navigate(`/teams/${tmNew.id}`)
  }

  if (!isReady || currentUser == null) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  } else {
    return (
      <div className="Schedule">
        <div className="league-content">
          <div className="league-body">
            <p className='league-admin-back-button'><a className='league-link' href="/admin"><b>← Back to Admin Home</b></a></p>
            <p className='league-admin-back-button'><a className='league-link' href="/admin/teams"><b>← Back to Admin &gt; Teams</b></a></p>

            <p className="league-title-standard-secondary text-align-center">Create Team</p>
            <div className="league-table-container schedule large-item-buttons-admin">

            { displayEditTeam() }
            </div>
          </div>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default AdminTeamsNew;
